import advancedFormat from 'dayjs/plugin/advancedFormat'
import calendar from 'dayjs/plugin/calendar'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import timeDiff from './timeDiff/index.js'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(advancedFormat)
dayjs.extend(calendar)
dayjs.extend(customParseFormat)
dayjs.extend(isBetween)
dayjs.extend(timeDiff)
dayjs.extend(utc)
dayjs.extend(timezone)
